import { RotateCcw } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useLanguage } from "@/i18n/LanguageContext";

export const ResetProfileDialog = ({ onConfirm }) => {
  const { t } = useLanguage();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          data-testid="profile-reset-button"
          className="text-xs text-[hsl(var(--muted-foreground))] hover:text-red-400 transition-colors flex items-center gap-1.5"
        >
          <RotateCcw size={12} /> {t("profile.resetLink")}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-2xl bg-[#0B1220] border-white/10 max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("profile.resetTitle")}</AlertDialogTitle>
          <AlertDialogDescription>{t("profile.resetDesc")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid="profile-reset-cancel"
            className="rounded-xl bg-white/5 border-white/10 hover:bg-white/10 hover:text-white"
          >
            {t("profile.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="profile-reset-confirm"
            onClick={onConfirm}
            className="rounded-xl bg-red-500/90 text-white hover:bg-red-500"
          >
            {t("profile.confirmReset")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
